<template>
  <modal-default
    ref="modal"
    title="Select Default Status"
    :short-circuit-close="true"
    @close="cancelAndClose"
  >
    <form-field-select-status v-model="selectedStatusId"></form-field-select-status>

    <template v-slot:footer>
        <button-default
            @click="cancelAndClose"
        >Cancel</button-default>

        <button-default @click="install" :disabled="!selectedStatusId"
        >Install</button-default>
    </template>
  </modal-default>
</template>

<script>
import ModalBase from "../../../components/modal/ModalBase";
import {destroyModal} from "../../../services/modals";

export default {
  name: "SelectStatusForSharableInstallModal",
  components: {ModalBase},
  props: {
  },
  mounted() {
    this.$refs.modal.open();
  },
  data() {
    return {
      selectedStatusId: null
    }
  },
  computed: {
  },
  methods: {
    install() {
      this.$emit('selectedStatus', this.selectedStatusId);
      destroyModal(this.$refs.modal);
    },
    cancelAndClose() {
      destroyModal(this.$refs.modal);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.message {
  margin-bottom: 0.5rem;
  line-height: 1.3;
}
</style>
